<template>
  <b-container class="calculator">
    <b-row>
      <b-tabs v-model="tabIndex" content-class="justified" class="col-12 col-lg-8 p-lr-30">
        <CalculatorOne v-on:incrementTab="onIncrementTab" v-bind:tabIndex="tabIndex" />
        <CalculatorTwo v-on:incrementTab="onIncrementTab" v-bind:tabIndex="tabIndex" />
        <CalculatorThree v-bind:tabIndex="tabIndex" />
      </b-tabs>
      <SidePanel v-bind:tabIndex="tabIndex" class="col-12 col-lg-4 px-4 px-lg-0" />
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import CalculatorOne from "@/components/CalculatorOne";
import CalculatorTwo from "@/components/CalculatorTwo";
import CalculatorThree from "@/components/CalculatorThree";
import SidePanel from "@/components/SidePanel";

export default {
  name: "home",
  components: {
    CalculatorOne,
    CalculatorTwo,
    CalculatorThree,
    SidePanel
  },
  data() {
    return {
      tabIndex: 1
    };
  },
  methods: {
    onIncrementTab: function() {
      this.tabIndex++;
    }
  }
};
</script>

<style>
.calculator .nav-item {
  width: 30%;
}
</style>
